import { render } from "./CounselorManage.vue?vue&type=template&id=d3ee4b1a&scoped=true"
import script from "./CounselorManage.vue?vue&type=script&lang=js"
export * from "./CounselorManage.vue?vue&type=script&lang=js"

import "./CounselorManage.vue?vue&type=style&index=0&id=d3ee4b1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ee4b1a"]])

export default __exports__